import formatDate from '@/services/general/formatDate';
import moment from 'moment';

export default function validation(response, messages) {
  if (!response.data || !response.data.error || !response.data.error.validationErrors) {
    return;
  }

  response.data.error.validationErrors.forEach((error) => {
    const message = error.message;
    if (message.indexOf('LETTRAGE_AMOUNT_GREATER_THAN_MOUVEMENTS') === 0) {
      messages.push({
        message: 'remiseBancaire.ajoutReglement.errors.amountGreaterThanMouvements',
      });
    }
    if (message.indexOf('SHOULD_BE_NO_LETTERED') === 0) {
      messages.push({
        message: 'remiseBancaire.ajoutReglement.errors.notLettered',
      });
    }
    if (message.indexOf('LETTRAGE_AMOUNT_LESS_ZERO') === 0) {
      messages.push({
        message: 'remiseBancaire.ajoutReglement.errors.lettrageAmountLessZero',
      });
    }
    if (message.indexOf('LETTRAGE_DIFFERENT_CLIENTS') === 0) {
      messages.push({
        message: 'remiseBancaire.ajoutReglement.errors.differentClient',
      });
    }
    if ((message.indexOf('LETTRAGE_ONLY_ONE_CREDIT_MOUVEMENT') === 0)
    || (message.indexOf('LETTRAGE_ONLY_ONE_DEBIT_MOUVEMENT|') === 0)) {
      messages.push({
        message: 'remiseBancaire.ajoutReglement.errors.lettrageOnlyOneCreditDebitMouvement',
      });
    }
    if (message.indexOf('LETTRAGE_ONLY_ONE_PER_MOUVEMENT_PAIR') === 0) {
      messages.push({
        message: 'remiseBancaire.ajoutReglement.errors.lettrageOnlyOnePerMouvementPair',
      });
    }
    if (message.indexOf('MOUVEMENT_CLIENT_FORBIDDEN_TO_CANCEL_CANCELLED_PAYMENT') === 0) {
      const params = message.split('|')[0].split('@');
      messages.push({
        message: 'annulerReglement.messages.forbiddenToCancelCancelledPayment',
        parametres: {
          date: formatDate(moment(params[1])),
          montant: params[2],
        },
      });
    }
    if (message.indexOf('MOUVEMENT_CLIENT_FORBIDDEN_TO_CANCEL_CANCELLATION_OF_PAYMENT') === 0) {
      const params = message.split('|')[0].split('@');
      messages.push({
        message: 'annulerReglement.messages.forbiddenToCancelCancellationOfPayment',
        parametres: {
          date: formatDate(moment(params[1])),
          montant: params[2],
        },
      });
    }
    if (message.indexOf('MOUVMENT_CLIENT_NO_LINK') === 0) {
      messages.push({
        message: 'annulerReglement.messages.forbiddenToCancelPaymentNotLettered',
      });
    }
    if (message.indexOf('FORBIDDEN_TO_UPDATE_LETTERED_CUSTOMER_TRANSACTION') === 0) {
      messages.push({
        message: 'annulerReglement.messages.forbiddenCreateOrUpdateLetteredTransaction',
      });
    }
  });
}
